import { IMainstreetEvent, ICalendarState, IEventFilter, defaultCalendarModel, IEventMonth } from './classes';
import { ActionType } from './actions';
import * as moment from 'moment';
import * as _ from 'lodash';

export interface ICalendarStateAction {
    type: ActionType;
    value?: any;
}


/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export function reduce(state: ICalendarState<IMainstreetEvent> = defaultCalendarModel, action: ICalendarStateAction) {
    switch (action.type) {
        case ActionType.NextMonth: {
            // state.startDate.add(1, 'month').startOf('month');
            let newEndDate = state.endDate.clone().add(1, 'month').endOf('month');

            let newStartDate = state.startDate.clone().add(1, 'month').startOf('month');
            let newCurrMoment = state.currentDate.clone().add(1, "month");

            return _.assign({}, state, { offset: 0, updating: true, specificDates: false, currentDate: newCurrMoment, endDate: newEndDate, startDate: newStartDate }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.PreviousMonth: {
            let newEndDate = state.endDate.clone().add(-1, 'month').endOf('month');

            let newStartDate = state.startDate.clone().add(-1, 'month').startOf('month');
            let newCurrMoment = state.currentDate.clone().add(-1, "month");

            if (newCurrMoment.isBefore(state.startDate)) {
                return _.assign({}, state, { updating: true, specificDates: false, currentDate: newCurrMoment, startDate: newStartDate, endDate: newEndDate }) as ICalendarState<IMainstreetEvent>;
            }
            return _.assign({}, state, { offset: 0, currentDate: newCurrMoment }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.SetDates: {
            state.startDate = action.value.startDate;
            state.endDate = action.value.endDate;
            const updating = true;
            return _.assign({}, state, { offset: 0, updating, specificDates: true }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.ApplyMonthFilter: {
            if (action.value === "All Months") {
                let currentMonth = moment().startOf('month');
                state.startDate = currentMonth;
                state.endDate = moment(currentMonth).add(11, 'month').endOf('month');
                state.showAllMonths = true;
                state.pageSize = 20;
            } else {
                state.showAllMonths = false;
                state.startDate = moment(action.value).startOf('month');
                state.endDate = moment(action.value).endOf('month');
                state.pageSize = 1000;
            }

            const updating = true;
            return _.assign({}, state, { offset: 0, updating, specificDates: true }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.EventUpdated: {
            return _.assign({}, state, { updating: false }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.BrowserNavigated: {
            state = action.value.state;
            state.updating = action.value.shouldUpdate;
            return state as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.UpdateEvents: {
            const events = action.value.events as IEventMonth<any>;
            const hasMoreEvents = action.value.hasMoreEvents;

            return _.assign({}, state, { updating: false, events, hasMoreEvents }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.ApplyCourseTypeFilter: {
          
            const updating = true;

            var filterExists = state.courseTypeFilter.some(courseType => courseType === action.value);
            if (filterExists) {
                let newCourseTypeFilters = state.courseTypeFilter.filter(courseType => courseType !== action.value);
                return _.assign({}, state, { offset: 0, courseTypeFilter: newCourseTypeFilters, updating }) as ICalendarState<IMainstreetEvent>;

            } else {
                state.courseTypeFilter.push(action.value);
                let newCourseTypeFilters = state.courseTypeFilter;
                return _.assign({}, state, { offset: 0, courseTypeFilter: newCourseTypeFilters, updating }) as ICalendarState<IMainstreetEvent>;
            }
        }
        case ActionType.ApplyEventTypeFilter: {
           
            const updating = true;

            var filterExists = state.eventTypeFilter.some(eventType => eventType === action.value);
            if (filterExists) {
                let newEventTypeFilters = state.eventTypeFilter.filter(eventType => eventType !== action.value);
                return _.assign({}, state, { offset: 0, eventTypeFilter: newEventTypeFilters, updating }) as ICalendarState<IMainstreetEvent>;

            } else {
                state.eventTypeFilter.push(action.value);
                let newEventTypeFilters = state.eventTypeFilter;
                return _.assign({}, state, { offset: 0, eventTypeFilter: newEventTypeFilters, updating }) as ICalendarState<IMainstreetEvent>;
            }
        }
        case ActionType.ApplyInstructorFilter: {
            const instructorFilter = action.value;
            const updating = true;

            return _.assign({}, state, { offset: 0, instructorFilter, updating }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.ApplyLocationFilter: {
            const locationFilter = action.value;
            const updating = true;

            return _.assign({}, state, { offset: 0, locationFilter, updating }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.ApplyFormatFilter: {
            const updating = true;

            var filterExists = state.formatFilter.some(format => format === action.value);
            if (filterExists) {
                let newFormatFilters = state.formatFilter.filter(format => format !== action.value);
                return _.assign({}, state, { offset: 0, formatFilter: newFormatFilters, updating }) as ICalendarState<IMainstreetEvent>;

            } else {
                state.formatFilter.push(action.value);
                let newFormatFilters = state.formatFilter;
                return _.assign({}, state, { offset: 0, formatFilter: newFormatFilters, updating }) as ICalendarState<IMainstreetEvent>;
            }
        }
        case ActionType.ResetFilters: {
            const updating = true;
            return _.assign( {}, state, { offset: 0, formatFilter: [], locationFilter: '', showOnlyFreeEvent: false, courseTypeFilter: [], eventTypeFilter: [], instructorFilter: '', startDate: moment().startOf( 'month' ), endDate: moment().add( 11, 'month' ).endOf( 'month' ), updating }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.TogglePriceFilter: {
            const updating = true;
            return _.assign({}, state, { offset: 0, showOnlyFreeEvent: !state.showOnlyFreeEvent, updating }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.GetNextEvents: {
            const updating = true;
            return _.assign({}, state, { offset: action.value + 1, updating }) as ICalendarState<IMainstreetEvent>;
        }
        case ActionType.GetPreviousEvents: {
            const updating = true;
            return _.assign({}, state, { offset: action.value - 1, updating }) as ICalendarState<IMainstreetEvent>;
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/calendar-reducer.ts